<template>
	<div class="content">
		
      <van-swipe :autoplay="3000" :height="125">
       <van-swipe-item v-if="banners.length==0">
        <a class="banner-a" href="#">
          <img class="banner-img" src="../../assets/Banner.jpg" />
        </a>
       </van-swipe-item> 

      <van-swipe-item v-for="(item, index) in banners" :key="index">
        <a class="banner-a" :href="!item.LinkUrl ? '#' : item.LinkUrl">
          <img class="banner-img" :src="item.UrlAbsolutelPath" />
        </a>
      </van-swipe-item>
    </van-swipe>
        <div class="head-tips">
           <van-notice-bar :text="notice" left-icon="volume-o" />
       </div>
		<div class="search_area">
			<div class="lineType">
				<div v-for="(item,index) in lineType"
				:key="index"
				@click="changeItem(item)"
				:class="'lineTypeItem '+
				 (item.type==alterLineType.type?'lineTypeItemActive':'')">
				{{item.typeName}}
				</div>
			</div>

			<div class="terminalSelect">
				<van-radio-group v-model="selectSatation" direction="horizontal" class="terminalSelectRadio">
					<van-radio  v-for="(item,index)  in sttagNameList" :key="index" :value="item"
					:name="item" icon-size="15px" class="radio-Terminal">{{item}}</van-radio> 
				</van-radio-group>
			</div>

			<div class="selectDate" v-on:click="dateShow()" >
              <span class="dateSpan">
                <span class="iconfont icon-yuandianzhong color-green"></span>
                <span v-show="goDate" class="dateSpanText">{{ goDate | dateToStr}}</span>
                <span v-show="!goDate" class="dateSpanText">请选择</span>
              </span>
            </div>


			<div class="selectNode" @click="gotoUrl(alterLineType.type)">             
                <span class="dateSpan">
				 <span class="iconfont icon-yuandianzhong "></span>
                  <span v-if="Node.gid" class="nodeSelectText">{{Node.name}}</span>
                  <span v-else class="nodeUnSelectText">{{alterLineType.placeHolder}}</span>
                </span>
            </div>

		</div>

		<div class="btnSearchArea" >
				<div :class="'btnSearch '+'theme-'+sysTheme+'-btn'"  @click="gotoUrl(3)">查询</div>
		</div>

		
		<itemsPager v-if="classSelectedhist.length>0"
			     :itemTitle="'历史行程'"
				 :items="classSelectedhist"
				  @itemClick="itemClick"
				 />
	
		<van-tabbar>
			<van-tabbar-item icon="search" @click="gotoUrl(5)">职工购票</van-tabbar-item>
			<van-tabbar-item icon="friends-o" @click="gotoUrl(4)">我的</van-tabbar-item>
		</van-tabbar>


		<van-popup v-model="calendarShow" position="bottom" :overlay="true">S</van-popup>
		<calendar v-model="calendarShow"  :canselectdatelist="canSelectDateList" v-on:change="dateConfirm"></calendar>
	

	</div>

	
</template>

<script>
/* eslint-disable */
	import { 
		Swipe, SwipeItem,NoticeBar,Calendar,Cell, CellGroup,Col,Popup,RadioGroup, Radio,Icon,Tabbar, TabbarItem
	} from 'vant';
	import calendar from 'components/calendar'
	import itemsPager from 'components/itemsPager'
	import sysSettings from 'mixins/settings'

	export default {
		components: {
				[Swipe.name]: Swipe,
				[SwipeItem.name]: SwipeItem,
				[Col.name]: Col,
				[NoticeBar.name]: NoticeBar,
				[Popup.name]: Popup,
				[Cell.name]:Cell,
				[CellGroup.name]:CellGroup,
				[RadioGroup.name]:RadioGroup,
				[Radio.name]:Radio,
				[Icon.name]:Icon,
				[Tabbar.name]:Tabbar,
				[TabbarItem.name]:TabbarItem,
			    calendar: calendar,
				itemsPager
		},
		data() {
			return {
				notice:'',
				selectSatation: '',
				sttagNameList:[],
				topNodeCityList:[],
				banners:[],
				Node: { gid: '', name: '' },
				show: false,
				goDate: '',
				calendarShow: false,
				classSelectedhist:[],
				canSelectDateList: [],
				alterLineType:{ typeName: "从机场出发", type: 2 ,placeHolder:"到哪里去"},
				lineType: [{ typeName: "市区-机场", type: 1 ,placeHolder:"从哪出发"}, 
				{ typeName: "从机场出发", type: 2 ,placeHolder:"到哪里去"}],
			}
		},
		mixins:[
			sysSettings
		],
		watch:{
			getNode(newVal) {
     		   this.Node = newVal
       		},
		},
		computed: {
			getNode() {
				return this.alterLineType.type==1?
					this.$store.state.startNode:
					this.$store.state.endNode 
			},
		
			
		},    
		methods: {
					
			changeItem(item){
				if(this.alterLineType.type!=item.type){
					this.alterLineType=item
					this.$store.dispatch("setDirection", item)
					this.Node= { gid: '', name: '' }
				}

				let Node = {
					gid:"",
					name: "",
					type:this.alterLineType.type
				};

				this.$store.dispatch("setNode", Node);
			},
			itemClick(item){

			  let url = 'placeorder.html?'
      			url += this.$utils.getMainUrlParam(1)
				url += '&gid=' + item.GID
				url += '&sgid=' + (item.WaitStCode?item.WaitStCode:item.StartNodeGID)
				url += '&agid=' + item.ArrivalNodeGID		
				url += '&date=' + this.$moment().format('YYYY-MM-DD')
				url += '&node=' + item.ArrivalNodeGID
				url += '&line=' + item.LineName     
				url += url.includes('st=')?'':'&st=' + item.StartNodeGID			
				if(item.LineType){
					url+='&RedirectTag=employee&bus=&hashtag=employeeOrder#/employeeOrder'
				}

				//前往下单页面
				location.href = url

			},
			 //设置广告
			setBanner(){
				let that = this
				that.banners = []
				let imgStr = that.settings.HeadImgList
				if (imgStr) {
				let imgjs = eval('('+imgStr+')')
				if(imgjs.length>0){
					imgjs.forEach(function(v) {
					v.UrlAbsolutelPath = v.UrlAbsolutelPath.replace('http:', '')
					that.banners.push(v)
					})
				}
				}
			},
			//设置售票最大时间范围
			setSaleLimitDate(){
				let that = this
				let list = []
				let preSaleDate=that.settings.preSaleDate||60  
				for (let i = 0; i < preSaleDate; i++) {
				let day = this.$moment()
					.add(i, 'days')
					.format('YYYY-MM-DD')
				list.push(day)
				}
				this.goDate = this.$moment().format('YYYY-MM-DD')
				this.canSelectDateList = list
			},
			pageInit() {
				let that = this	

				that.setBanner()
				that.setSaleLimitDate()
						
				//设置主页面标题
				document.title =  that.settings.IndexTitle!=''?that.settings.IndexTitle:'购票'

				//设置通知栏
				that.notice = that.settings.IndexNoteText? that.settings.IndexNoteText: '欢迎使用微信购票~_~'
				
				//始发站标签名列表
				that.sttagNameList=that.settings.IndexStTagNameList.split(',')
				that.selectSatation=that.sttagNameList[0]

				//需置顶目的站列表
				that.topNodeCityList=that.settings.topNodeCityList
				that.alterLineType=that.$store.state.direction || that.alterLineType

				//获取班次历史行程
		        that.classSelectedhist=this.getLocalData("classSelectHist").items||[]
			},
			//链接跳转
			gotoUrl: function(type) {
				let url = ''			
				switch (type) {
					case 1:	
					    //查询发车站					
						url = {
							name: 'nodeSelect',
							query: this.$utils.getMainUrlParam(2)
						}
						
						let dstNode = {
								gid: this.selectSatation,
								name: this.selectSatation,
								type:2
						};
						this.$store.dispatch("setNode", dstNode);

						url.query.nodeType = 3
						url.query.arriveNode = this.selectSatation
						url.query.schDate = this.goDate
					break;
				
					case 2:
					   //查询目的地
						url = {
							name: 'nodeSelect',
							query: this.$utils.getMainUrlParam(2)
						}
								
						let startNode = {
								gid: this.selectSatation,
								name: this.selectSatation,
								type:1
						};
						this.$store.dispatch("setNode",startNode); 
						url.query.nodeType = 2
						url.query.startNodeGID = this.selectSatation
						url.query.topNodeCityList = this.topNodeCityList
					break;
				
					case 3:
				       //跳转到班次查询
						if (this.Node.name) {
							url = {
							name: 'classSelect',
							query: this.$utils.getMainUrlParam(2)
							}
							url.query.date = this.goDate
						}
						if (!this.Node.name) {
							this.$dialog.alert({
								title: '提示',
								message: '请选择上下车点'
							})
						}
						break;
					case 4:
						 //跳转到用户中心
						location.href = 'userhome.html?' + this.$utils.getMainUrlParam(1)
					break;
					case 5:
						 //跳转到用户中心
						location.href = 'employee.html?' + this.$utils.getMainUrlParam(1)
					break;
					default:
					break;
				}
				if (url) {
				
					this.$router.push(url)
				}
			},

			dateShow(flag=true){
						this.calendarShow = flag
			},
			dateConfirm(date, formatDate) {
						date = this.$moment(date).format('YYYY-MM-DD')
						this.goDate = date
						this.dateShow(false)
			}
		},
		created() {

            //获取系统设置
			this.getSettings().then(setting=>{       
				//设置系统主题
				this.setSysTheme(setting.sysTheme)
				//页面初始化
				this.pageInit(setting)
			})


		}
		
	}
</script>

<style lang="less" scoped>
	.banner-a,
	.banner-img {
		display: block;
		width: 100%;
		height: 100%;
	}
	
	.content {
		height: 100%;
		width: 100%;
		background-color: #f1f1f1;

	}
	.head-tips {
		line-height: 48px;
		background-color: #fff;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		font-size: 16px;
	}
	.head-tips .van-notice-bar {
		background-color: #fff;
		color: #333;
	}

	.search_area {
		width: 95%;	
		//height: 300px;
		margin: 10px auto;
		background-color: #FFFFFF;	
		display:flex;
		flex-direction: column;
		//border: 0px #f58c0c solid;
		//border: 1px #dad1d1 solid;
		border-top:none;
	}
	.lineType{
		display: flex;
		flex-direction: row;
		height:40px;
		// border: 1px #f58c0c solid;
		// border-top:none;
		// border-bottom:none;

		.lineTypeItem {
			width: 50%;
			background-color: #fafafa;
			color: #d1d0d0;
			font-size: 20px;
			line-height: 40px;
			text-align: center;
			margin-bottom: 0px;
			border-top:none;
			border-bottom: 1px solid #eee;
			
		}
		.lineTypeItemActive{
			//background-color: #f58c0c;
			background-color: #ffffff;
			border: 1px solid #eee;
			color: #545454;
			border-top: 2px solid #f58c0c;
			border-bottom: none;
			margin-top: -5px;
			font-weight: 500; 
		}	
	}

	.terminalSelect{
		display: flex;
		flex-direction: row;
		border-top:none;
		border-bottom: 1px #eee solid;
		font-size: 20px;
		width: 90%;
		margin: 10px auto;
		padding-bottom: 15px;
	
		.terminalSelectRadio{
			margin:10px 5px 5px;
			min-width: 80px;
			font-size: 20px;
			font-weight: bold;
			
		}

		.radio-Terminal{
			margin:0px 10px 5px 0px;
		}
	}

	.selectDate{
		width: 90%;
		margin: 0 auto;
		line-height: 40px;
		text-align: left;
		border-bottom: 1px #eee solid;
		
		.dateSpan{
			font-size: 20px;
		}

		.dateSpanText{
			font-size: 20px;
			margin-left: 25px;
		}
	}

	.selectNode{
		width: 90%;
		position: relative;
		margin: 0 auto;
		line-height: 40px;
		text-align: left;
		border-bottom: 1px #eee solid;
		font-size: 24px;

		.nodeSelectText{
			//font-size: 20px;
			margin-left: 25px;
		}

		.nodeUnSelectText{
	     	//	font-size: 20px;
			margin-left: 25px;
			color: #c1c1c1;
		}
	}

	.icon-yuandianzhong {
		line-height: 40px;
		text-align: center;
		font-size: 14px;
		color: #e88a1b;
	}

	.icon-yuandianzhong.color-green {
		color: #23a737;
	}

	.btnSearchArea{
		width: 95%;
		margin: 0 auto;
		
		.btnSearch{		
			line-height: 40px;
			font-size: 20px;
		}
	}

	.btn-mine{
		position:fixed;
		bottom: 2rem;
		right: .3rem;
		height: 1.3rem;
		width: 1.3rem;
		border-radius: 50%;
		z-index: 30;
		text-align: center;  

   .icon{
 
     text-align: center;
     line-height: .35rem;
     font-size: .35rem;
     margin-top: .2rem;
   }

   .title{
      text-align: center;
      font-size:.22rem;
      line-height: .35rem;
   }


}
</style>
